export default "__VITE_ASSET__DfqlxFBT__"